import deepEqual from "deep-equal"
import { AloAccompagnement } from "./AloAccompagnement"
import { AloArbo } from "./AloArbo"
import { AloBaseLg } from "./AloBaseLg"
import { AloPlat, getDefaultAloPlat } from "./AloPlat"
import { QtyItem } from "./QtyItem"
import  {uuidv4} from "@/utils/uuid"

export interface IItemPanier {
    uuid?: string
    sectionId?: number|null
    arboId?: number|null
    parentId?: number|null
    plat?: AloPlat
    accompagnements?:Array<QtyItem<AloAccompagnement|AloPlat>>
    parfum?:{lgs:Array<AloBaseLg>}|Array<{lgs:Array<AloBaseLg>}>
    commentaire?: string
    qty?:number
    cuisson?: {lgs:Array<AloBaseLg>}
    cuissonOeuf?:string
    tempsCuisson?:number
    options?:{[arboId:number]:Array<IItemPanier>}
    supplements?:Array<IItemPanier>
    heureDebut?:string
    heureFin?:string
    tempsPreparation?:number
}

export class ItemPanier  {    
    
    public uuid:string
    public sectionId:number|null
    public arboId:number|null    
    public parentId:number|null    
    public plat:AloPlat
    public accompagnements:Array<QtyItem<AloAccompagnement|AloPlat>>
    public parfum?:{lgs:Array<AloBaseLg>}|Array<{lgs:Array<AloBaseLg>}>
    public commentaire?:string
    public qty:number
    public cuisson?:{lgs:Array<AloBaseLg>}
    public cuissonOeuf?:string
    public tempsCuisson?:number
    public options?:{[platId:number]:Array<ItemPanier>}
    public supplements:Array<ItemPanier>    
    

    constructor({sectionId,arboId,parentId,plat,accompagnements,parfum,commentaire,qty,cuisson,cuissonOeuf,tempsCuisson,supplements,options,heureDebut,heureFin,tempsPreparation,uuid}:IItemPanier = {} as IItemPanier) {
        this.uuid = uuid ?? uuidv4()
        this.sectionId = sectionId || null
        this.arboId = arboId || null
        this.parentId = parentId || null
        this.plat = plat ?? getDefaultAloPlat()
        this.accompagnements = accompagnements ?? []
        this.parfum = parfum
        this.commentaire = commentaire || ""
        this.qty = qty ?? 0
        this.cuisson = cuisson        
        this.cuissonOeuf = cuissonOeuf
        this.tempsCuisson = tempsCuisson ?? -1        
        this.options = options? Object.keys(options).reduce((opt,key) => {
            opt[Number.parseInt(key)] = options[Number.parseInt(key)].map(it => new ItemPanier(it))
            return opt
        },{} as {[platId:number]:Array<ItemPanier>})  : {}        
        this.supplements = supplements?.map(it => new ItemPanier(it)) ?? []
    }                
    
    public get prixAvecOptions() {   
        return    (this.plat.prix ?? 0)  //Prix du plat
                + this.prixSupplementsAccompagnement //Prix du supplement accompagnement                
                + this.prixSupplementsCarte //Prix supplement carte
    }

    public get prixSupplementsCarte():number{
        return this.supplements?.reduce((total,s)=> total+s.prixTotalAvecOptions,0) ?? 0
    }

    public get prixSupplementsAccompagnement() {
        return this.nbAccompagnementsPayant * (this.plat.prixAccompagnement ?? 0)
    }
    
    public get nbAccompagnements(){
        return this.accompagnements.reduce((total,item) => total+item.qty,0)
    }

    public get nbSupplements(){
        return this.supplements?.reduce((total,item) => total + item.qty,0) ?? 0
    }

    public get nbAccompagnementsPayant() {
        return Math.max(this.nbAccompagnements - (this.plat.qtyAccompagnementGratuit ?? 0),0)
    }

    public get prixTotalAvecOptions() {   
        return (this.prixAvecOptions * this.qty)
    }       
    
    public hasSameConfig(item:ItemPanier) {
        return this.plat.id == item.plat.id && deepEqual(this.parfum,item.parfum) && deepEqual(this.cuisson,item.cuisson) && this.cuissonOeuf == item.cuissonOeuf && this.commentaire == item.commentaire && deepEqual(this.accompagnements,item.accompagnements) && deepEqual(this.supplements,item.supplements) && deepEqual(this.options,item.options)
    }
}